import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { States } from "app/_models/states";
import { Cities } from "app/_models/cities";
import { Warehouses } from "app/_models/warehouses";
import { StateService } from "app/_services/state.service";
import { CrudWarehouseService } from "app/_services/MasterCrudOps/crud-warehouse.service";
import { UserOptionsDto } from "app/_models/optionsList/options";
import { OptionslistService } from "app/_services/optionslist.service";
declare const swal: any;

@Component({
  selector: "app-edit-warehouse",
  templateUrl: "./edit-warehouse.component.html",
  styleUrls: ["./edit-warehouse.component.css"],
})
export class EditWarehouseComponent implements OnInit {
  editWarehouseForm: FormGroup;
  userOptionsDto: UserOptionsDto[] = [];
  states: States[];
  state: States;
  cities: Cities[] = [];
  city: Cities;
  editHouse: Warehouses;
  pageNumber: number;
  pageSize: number;

  constructor(
    private readonly fb: FormBuilder,
    private readonly stateService: StateService,
    private readonly optionslistService: OptionslistService,
    private readonly crudWarehouseService: CrudWarehouseService,
    private readonly dialogRef: MatDialogRef<EditWarehouseComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.editHouse = JSON.parse(JSON.stringify(data.warehouse));
    this.pageNumber = data.pageNumber;
    this.pageSize = data.pageSize;
    this.getStates();
    this.getCitiesByStateId();
  }

  ngOnInit(): void {
    this.editWarehouseForm = this.fb.group({
      stateId: [this.editHouse.stateId, [Validators.required]],
      cityId: [this.editHouse.cityId, [Validators.required]],
      warehouseName: [
        this.editHouse.warehouseName ?? "",
        [Validators.required, Validators.maxLength(50)],
      ],
      address: [
        this.editHouse.address ?? "",
        [Validators.required, Validators.maxLength(250)],
      ],
      description: [
        this.editHouse.address ?? "",
        [Validators.required, Validators.maxLength(100)],
      ],
      warehouseManagerId: [this.editHouse.warehouseManagerId ?? null],
    });
    this.getUsers();
  }

  getStates() {
    this.stateService.getStates().subscribe((states) => {
      this.states = states;
      this.state = this.states.find((s) => s.id === this.data.stateId)!;
    });
  }

  getCitiesByStateId() {
    this.stateService
      .getCityByStateId(this.editHouse.stateId)
      .subscribe((response) => {
        this.cities = response.cities;
        for (let i = 0; i < response.cities.length; i++) {
          if (this.cities[i].cityId == this.data.cityId) {
            this.cities.push(response.cities[i]);
            break;
          }
        }
      });
  }

  onCloseDialog(): void {
    this.dialogRef.close();
  }

  saveWareHouse() {
    swal({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: "btn btn-success",
      cancelButtonClass: "btn btn-danger",
      confirmButtonText: "YES, Update IT!",
    }).then((result) => {
      if (result === true) {
        this.UpdateWareHouse();
      }
    });
  }

  UpdateWareHouse() {
    let model = {
      warehouseId: this.editHouse.warehouseId,
      warehouseName: this.editWarehouseForm.value.warehouseName,
      description: this.editWarehouseForm.value.description,
      cityId: this.editWarehouseForm.value.cityId,
      stateId: this.editWarehouseForm.value.stateId,
      address: this.editWarehouseForm.value.address,
      warehouseManager: this.editWarehouseForm.value.warehouseManagerId,
    };
    this.crudWarehouseService.updateWareHouse(model).subscribe(
      (data) => {
        if (data.didError) {
          swal({
            title: "",
            text: data.message,
            type: "error",
            confirmButtonClass: "btn btn-info",
          });
        } else {
          this.dialogRef.close(true);
          swal({
            title: "",
            text: data.message,
            type: "success",
            confirmButtonClass: "btn btn-info",
          });
          let result = {
            status: true,
            pageNumber: this.pageNumber,
            pageSize: this.pageSize,
          };
          this.dialogRef.close(result);
        }
      },
      (error) => {
        let errorMessage =
          error.error?.title ??
          error.error ??
          "Something went wrong. Please contact admin.";

        // Check if it's a validation error response with the `errors` object
        if (error.error?.errors) {
          const allErrors = Object.values(error.error.errors).flat(); // Flatten all error arrays
          if (allErrors.length > 0) {
            errorMessage = allErrors[0]; // Use the first validation message
          }
        } else if (typeof error.error === "string") {
          errorMessage = error.error;
        } else if (error.error?.title) {
          errorMessage = error.error.title;
        }
        swal({
          title: "",
          text: errorMessage,
          type: "error",
          confirmButtonClass: "btn btn-info",
        });
      }
    );
  }
  close() {
    let result = {
      status: false,
      pageNumber: this.pageNumber,
      pageSize: this.pageSize,
    };
    this.dialogRef.close(result);
  }

  onSelectionchange(e) {
    this.editHouse.cityId = 0;
    this.stateService.getCityByStateId(e.value).subscribe((state) => {
      this.cities = state.cities;
    });
  }

  getUsers() {
    this.optionslistService
      .getActiveDatacentereManagersOptions()
      .subscribe((data) => {
        if (!data.didError) {
          this.userOptionsDto = data.model;

          // Set the manager if warehouseManagerId exists
          if (this.editHouse.warehouseManagerId) {
            const found = this.userOptionsDto.find(
              (u) =>
                u.userId.toLowerCase() ===
                this.editHouse.warehouseManagerId.toLowerCase()
            );
            if (found) {
              this.editWarehouseForm.patchValue({
                warehouseManagerId: found.userId,
              });
            } else {
              console.warn("Manager ID not found in user options");
            }
          }
        }
      });
  }
}
